import {Component, OnInit, ViewChild} from '@angular/core';
import {InformType} from '../../../../global/util/enum/InformType';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DocumentService} from '../../../service/document.service';
import {Constant} from '../../../../global/util/Constant';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {ApplicationService} from '../../../service/application.service';
import {Router} from '@angular/router';
import {AuthService} from '../../../service/auth/auth.service';
import {ReviewType} from '../../../../global/util/enum/ReviewType';
import {Dialog} from '../../../../global/util/Dialog';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {Document} from '../../../model/Document';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-review-document',
  templateUrl: './review-document.component.html',
  styleUrls: ['./review-document.component.css']
})
export class ReviewDocumentComponent implements OnInit {
  public loading: boolean;
  public document: Document;
  public documents: Document [];
  public reviewForm: FormGroup;
  public urlStream;
  public personId;
  public resourceList: any[] = [];
  public hasMultipleAttachments;
  public title = 'TITLE.DOCUMENT-REVIEW';
  public reviewType: number;
  private reviewInfos: any[];
  public reloadingPdf = false;
  public progressUpdate = 0;
  @ViewChild('pdfViewer') pdfViewer;

  constructor(private activeModal: NgbActiveModal,
              private modalService: NgbModal,
              private formBuilder: FormBuilder,
              private documentService: DocumentService,
              private applicationService: ApplicationService,
              private router: Router,
              private authenticationService: AuthService,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
    this.createForm();
  }

  ngOnInit() {
    this.createEntities();
    this.document = this.documents[0];
    if (ReviewType.One2One === this.reviewType) {
      this.hasMultipleAttachments = this.document._more.resources.length > 1;
    } else if (ReviewType.Batch === this.reviewType) {
      this.hasMultipleAttachments = this.documents.find(value => value._more.resources.length > 1) !== undefined;
    }
    this.reloadResourceList();
    const interval = setInterval(() => {
      if (!this.authenticationService.isAuthenticated()) {
        clearInterval(interval);
        this.activeModal.close(InformType.Anything);
      }
    }, 300);

  }

  private createForm() {
    this.reviewForm = this.formBuilder.group(
      {
        observed: [''],
        cancelled: [''],
        comment: [''],
        attach: [false],
        file: [null],
        filename: ['']
      });
  }

  private applyValidators() {
    const reviewInfo = this.getReviewInfoBy(this.document);
    const control = this.reviewForm.get('comment');
    if (reviewInfo.observed || reviewInfo.cancelled) {
      control.setValidators(Validators.required);
      control.updateValueAndValidity();
    } else if (!reviewInfo.observed && !reviewInfo.cancelled) {
      control.clearValidators();
      control.updateValueAndValidity();
    }
  }

  public changeObserved(event) {
    const reviewInfo: ReviewInfo = this.getReviewInfoBy(this.document);
    if (event.target.checked) {
      reviewInfo.observed = true;
      let control = this.reviewForm.get('cancelled');
      control.setValue(false);
      if (reviewInfo.cancelled) {
        reviewInfo.cancelled = false;
      }
      control = this.reviewForm.get('file');
      control.clearValidators();
      control.reset();
      control.updateValueAndValidity();
      control = this.reviewForm.get('filename');
      control.setValue('');
    } else {
      reviewInfo.observed = false;
    }
    this.applyValidators();
  }

  public changeCancelled(event) {
    const reviewInfo: ReviewInfo = this.getReviewInfoBy(this.document);
    if (event.target.checked) {
      reviewInfo.cancelled = true;
      let control = this.reviewForm.get('attach');
      control.setValue(false);
      if (reviewInfo.observed) {
        reviewInfo.observed = false;
      }
      control = this.reviewForm.get('file');
      control.clearValidators();
      control.reset();
      control.updateValueAndValidity();
      control = this.reviewForm.get('filename');
      control.setValue('');
    } else {
      reviewInfo.cancelled = false;
    }
    this.applyValidators();
  }

  public changeAttach(event) {
    let control = this.reviewForm.get('attach');
    if (event.target.checked) {
      control.setValue(true);
      control = this.reviewForm.get('file');
      control.setValidators(Validators.required);
      control.reset();
      control.updateValueAndValidity();
    } else {
      control.setValue(false);
      control = this.reviewForm.get('file');
      control.clearValidators();
      control.reset();
      control.updateValueAndValidity();
      control = this.reviewForm.get('filename');
      control.setValue('');
    }
  }

  private buildUrlSource() {
    this.urlStream = this.document._more.resources[0].url;
  }

  public isInvalidControl(ctrlName: string) {
    return this.reviewForm.get(ctrlName).invalid && this.reviewForm.get(ctrlName).touched;
  }

  public save(): void {
    if (this.reviewForm.invalid) {
      Object.values(this.reviewForm.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    const reviewInfo = this.reviewInfos.find(value =>
      (value.observed && (value.comment === undefined || value.comment === '')) ||
      (value.cancelled && (value.comment === undefined || value.comment === ''))
    );
    if (reviewInfo) {
      const document = this.documents.find(value => reviewInfo.documentId === value.id);
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.DOCUMENT-REVIEW'), (String(this.translate.instant('MESSAGE.REQUIRED-ENTER-COMMENTS-OBSERVATIONS')), String(document.subject)));
      return;
    }
    this.loading = true;
    if (this.hasUniqueDocument) {
      this.reviewOne2One();
    } else {
      this.reviewBatch();
    }
  }

  private reviewOne2One() {
    const reviewInfo: ReviewInfo = this.getReviewInfoBy(this.document);
    let url = Constant.ROOT_API_V1.concat('/documents/')
      .concat(String(this.document.id))
      .concat('/')
      .concat(this.document.hashIdentifier)
      .concat('/people/')
      .concat(String(this.personId));
    if (this.reviewForm.value.file) {
      url = url.concat('/review');
    } else {
      url = url.concat('/review2');
    }
    const formData = new FormData();
    formData.append('observed', String(reviewInfo.observed ? 1 : 0));
    formData.append('cancelled', String(reviewInfo.cancelled ? 1 : 0));
    formData.append('comment', this.reviewForm.value.comment);
    if (this.reviewForm.value.file) {
      formData.append('file', this.reviewForm.value.file);
    }
    this.documentService.reviewOne2One(url, formData).subscribe((event: HttpEvent<any>) => {
      switch (event.type) {
        case HttpEventType.Sent:
          // TODO When request has been made
          break;
        case HttpEventType.ResponseHeader:
          // TODO When response header has been received
          break;
        case HttpEventType.UploadProgress:
          this.progressUpdate = Math.round(event.loaded / event.total * 100);
          break;
        case HttpEventType.Response:
          this.loading = false;
          this.activeModal.close(InformType.Success);
          break;
      }
    }, error => {
      this.progressUpdate = 0;
      this.loading = false;
      this.processError(error);
    });
  }

  private reviewBatch() {
    this.setValuesBefore2Save();
    const url = Constant.ROOT_API_V1.concat('/people/', String(this.personId), '/documents/review');
    const revision = new Revision();
    revision.reviewInfos = this.reviewInfos;
    this.documentService.reviewBatch(url, revision).subscribe(next => {
      this.loading = false;
      this.activeModal.close(InformType.Success);
    }, error => {
      this.loading = false;
      this.processError(error);
    });
  }

  private setValuesBefore2Save() {
    this.reviewInfos.forEach(value => {
      if (value.observed) {
        value.observed = 1;
      } else {
        value.observed = 0;
      }
      if (value.cancelled) {
        value.cancelled = 1;
      } else {
        value.cancelled = 0;
      }
    });
  }

  public cancel(): void {
    this.activeModal.close(InformType.Anything);
  }

  public setUrlDoc(resource: any) {
    this.urlStream = resource.url;
    this.reloadPdfViewer();
  }

  private reloadPdfViewer(): void {
    this.reloadingPdf = true;
    const interval = setTimeout(() => {
      this.reloadingPdf = false;
    }, 300);
  }

  private processError(error: any) {
    const status = error.status;
    this.title = this.translate.instant('TITLE.DOCUMENT-REVIEW');
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, this.title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
        this.logout();
      } else {
        Dialog.show(InformType.Danger, this.title);
      }
    } else {
      Dialog.show(InformType.Danger, this.title, error.error.message);
    }
  }

  private logout() {
    this.applicationService.setUserLoggedIn(false);
    this.router.navigate(['login']);
  }

  public reloadResourceList() {
    this.resourceList = this.document._more.resources;
    this.setUrlDoc(this.resourceList[0]);
    this.buildUrlSource();
    this.applyValidators();
  }

  private createEntities() {
    this.reviewInfos = this.documents.map(value => {
      const reviewInfo: ReviewInfo = {
        documentId: value.id,
        hashIdentifier: value.hashIdentifier,
        observed: false,
        cancelled: false,
        comment: ''
      };
      return reviewInfo;
    });
  }

  private getReviewInfoBy(document: any) {
    return this.reviewInfos.find(value => document.id === value.documentId);
  }

  public keyupComment(event) {
    if (event.target) {
      const reviewInfo: ReviewInfo = this.getReviewInfoBy(this.document);
      reviewInfo.comment = event.target.value;
    }
  }

  get hasUniqueDocument(): boolean {
    return this.documents.length === 1;
  }

  public getObservedCheckedBy(document: any): boolean {
    const reviewInfo: ReviewInfo = this.getReviewInfoBy(document);
    return reviewInfo.observed;
  }

  public getCancelledCheckedBy(document: any): boolean {
    const reviewInfo: ReviewInfo = this.getReviewInfoBy(document);
    return reviewInfo.cancelled;
  }

  public getCommentBy(document: any): string {
    const reviewInfo: ReviewInfo = this.getReviewInfoBy(document);
    return reviewInfo.comment;
  }

  public changeStatus(event) {
    const fileSelected = (event.target as HTMLInputElement).files[0];
    if (!fileSelected.name.endsWith('.pdf')) {
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.DOCUMENT-REVIEW'), this.translate.instant('MESSAGE.SELECTED-NOT-ALLOWED-FILE'));
      return;
    }
    this.reviewForm.patchValue({
      file: fileSelected,
      filename: fileSelected.name
    });
    this.reviewForm.get('file').updateValueAndValidity();
  }

  get attachSelected(): boolean {
    return this.reviewForm.get('attach').value && this.hasUniqueAttach;
  }

  get hasUniqueAttach(): boolean {
    return this.resourceList.length === 1;
  }

  get cancelChecked(): boolean {
    return this.reviewForm.get('cancelled').value;
  }

  get observedChecked(): boolean {
    if (!this.cancelChecked) {
      return false;
    }
    return this.reviewForm.get('observed').value;
  }

  get closeStamping(): boolean {
    if (!this.hasUniqueDocument || !this.hasUniqueAttach) {
      return true;
    }
    return this.document.closedStamping;
  }
}

class ReviewInfo {
  documentId: number;
  hashIdentifier: string;
  observed: boolean;
  cancelled: boolean;
  comment: string;
}

export class Revision {
  reviewInfos: ReviewInfo[];
}
